import { Alert } from './Alert';
import { Confirm } from './Confirm';
import { alert, confirm } from './manual';
import { Modal as ModalComponent } from './Modal';
import { ModalFooter } from './ModalFooter';
var Modal = ModalComponent;
Modal.Footer = ModalFooter;
Modal.alert = alert;
Modal.confirm = confirm;
Modal.Alert = Alert;
Modal.Confirm = Confirm;
export { Modal };